<div class="item-container" [class]="className">
  <div class="item-icon">
    <div class="icon-background" [ngStyle]="{ 'background-color': color }">
      @if (srcIcon) {
        <img [src]="srcIcon" [alt]="itemText" />
      }
      @if (!srcIcon && iconName) {
        <mat-icon [svgIcon]="iconName" [ngStyle]="{ color: 'white' }"></mat-icon>
      }
    </div>
  </div>
  <div class="item-text-container">
    <h4 class="item-text">{{ itemText }}</h4>
    @if (itemSubtext) {
      <h4 class="item-subtext">{{ itemSubtext }}</h4>
    }
    @if (patientName) {
      <h4 class="item-subtext name">{{ patientName }}</h4>
    }
    @if (itemThirdText) {
      <h4 class="item-third-text">{{ itemThirdText }}</h4>
    }
    @if (stars !== undefined && stars !== null) {
      <div class="stars-container">
        <div class="stars-number">{{ stars | truncate: 1 }}</div>
        <app-score [score]="stars"></app-score>
      </div>
    }
  </div>

  <div class="suffix-text">
    @if (itemSuffixText) {
      <h5>{{ itemSuffixText }}</h5>
    }
    @if (itemSuffixSubtext) {
      <h5>{{ itemSuffixSubtext }}</h5>
    }
  </div>

  @if (displayArrow) {
    <div class="item-arrow">
      <mat-icon svgIcon="arrow" [ngClass]="{ south: south }" [ngStyle]="{ color: !south ? color : 'black' }"></mat-icon>
    </div>
  }

  @if (template) {
    <ng-container [ngTemplateOutlet]="template"> </ng-container>
  }
</div>
